import { render } from "./ListeTypeCargaisonPage.vue?vue&type=template&id=c9fe4060&ts=true"
import script from "./ListeTypeCargaisonPage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeCargaisonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__